import { type Images } from '@neos/app'
import addLicensePath from '../../modules/Activation/images/AddLicense.svg'
import addMonthPath from '../../modules/Core/images/AddMonth.svg'
import addYearPath from '../../modules/Core/images/AddYear.svg'
import arrowRightPath from '../../modules/Global/images/ArrowRight.svg'
import collapsePath from '../../modules/dependencies/UserPermissions.3.1.9/images/Collapse.svg'
import communicationPath from '../../modules/Global/images/Communication.svg'
import detailPath from '../../modules/Core/images/Detail.svg'
import doubleArrowHorizontalPath from '../../modules/Global/images/DoubleArrowHorizontal.svg'
import doubleArrowVerticalPath from '../../modules/Global/images/DoubleArrowVertical.svg'
import downPath from '../../modules/dependencies/UserPermissions.3.1.9/images/Down.svg'
import draftPath from '../../modules/Global/images/Draft.svg'
import enterprisesPath from '../../modules/Activation/images/Enterprises.svg'
import errorClusterPath from '../../modules/dependencies/UserPermissions.3.1.9/images/ErrorCluster.svg'
import expandPath from '../../modules/dependencies/UserPermissions.3.1.9/images/Expand.svg'
import externalClusterPath from '../../modules/dependencies/UserPermissions.3.1.9/images/ExternalCluster.svg'
import filterCollapsePath from '../../modules/Global/images/FilterCollapse.svg'
import filterExpandPath from '../../modules/Global/images/FilterExpand.svg'
import general_settingsPath from '../../modules/Core/images/General_settings.svg'
import helpPath from '../../modules/Global/images/Help.svg'
import homePath from '../../modules/Global/images/Home.svg'
import licensesPath from '../../modules/Activation/images/Licenses.svg'
import minusPath from '../../modules/Global/images/Minus.svg'
import neosDataImportDetailPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportDetail.svg'
import neosDataImportDownloadFilePath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportDownloadFile.svg'
import neosDataImportErrorPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportError.svg'
import neosDataImportFilePath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportFile.svg'
import neosDataImportHistoryPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportHistory.svg'
import neosDataImportIntegratePath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportIntegrate.svg'
import neosDataImportIntegrateAllPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportIntegrateAll.svg'
import neosDataImportIntegrationPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportIntegration.svg'
import neosDataImportKpiErrorRowCountPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportKpiErrorRowCount.svg'
import neosDataImportKpiInformationRowCountPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportKpiInformationRowCount.svg'
import neosDataImportKpiIntegratedRowCountPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportKpiIntegratedRowCount.svg'
import neosDataImportKpiProcessedRowCountPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportKpiProcessedRowCount.svg'
import neosDataImportKpiValidRowCountPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportKpiValidRowCount.svg'
import neosDataImportKpiWarningRowCountPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportKpiWarningRowCount.svg'
import neosDataImportRightArrowPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportRightArrow.svg'
import neosDataImportRunPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportRun.svg'
import neosDataImportSettingsPath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportSettings.svg'
import neosDataImportTemplatePath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportTemplate.svg'
import neosDataImportUploadFilePath from '../../modules/dependencies/NeosDataExchange.3.1.9/images/NeosDataImportUploadFile.svg'
import newPath from '../../modules/Core/images/New.svg'
import noDataPath from '../../modules/Core/images/NoData.svg'
import openInNewSharpPath from '../../modules/Global/images/OpenInNewSharp.svg'
import openTabPath from '../../modules/Core/images/OpenTab.svg'
import paymentsPath from '../../modules/Core/images/Payments.svg'
import plusPath from '../../modules/Global/images/Plus.svg'
import previewPath from '../../modules/Global/images/Preview.svg'
import printPath from '../../modules/Global/images/Print.svg'
import productEditingPath from '../../modules/Activation/images/ProductEditing.svg'
import rightPanelCollapsePath from '../../modules/Global/images/RightPanelCollapse.svg'
import rightPanelExpandPath from '../../modules/Global/images/RightPanelExpand.svg'
import roleUsersPath from '../../modules/dependencies/UserPermissions.3.1.9/images/RoleUsers.svg'
import rowInsertPath from '../../modules/Global/images/RowInsert.svg'
import sendEmailPath from '../../modules/Core/images/SendEmail.svg'
import sendSMSPath from '../../modules/Core/images/SendSMS.svg'
import statisticsPath from '../../modules/Activation/images/Statistics.svg'
import syncBlackPath from '../../modules/dependencies/UserPermissions.3.1.9/images/SyncBlack.svg'
import tenantPath from '../../modules/Activation/images/Tenant.svg'
import testEnvironmentPath from '../../modules/Global/images/TestEnvironment.svg'
import themesPath from '../../modules/Activation/images/Themes.svg'
import upPath from '../../modules/dependencies/UserPermissions.3.1.9/images/Up.svg'
import userAccountPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserAccount.svg'
import userClientPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserClient.svg'
import userFunctionPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserFunction.svg'
import userPermissionsSendEmailPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserPermissionsSendEmail.svg'
import userPermissionsSendSMSPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserPermissionsSendSMS.svg'
import userPublisherPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserPublisher.svg'
import verticalDotsPath from '../../modules/Global/images/VerticalDots.svg'

const images: Images = {
  add: 'add',
  addLicense: { path: addLicensePath, colored: false },
  addMonth: { path: addMonthPath, colored: false },
  addYear: { path: addYearPath, colored: false },
  arrowRight: { path: arrowRightPath, colored: false },
  close: 'close',
  collapse: { path: collapsePath, colored: false },
  collapseControl: 'collapse',
  communication: { path: communicationPath, colored: false },
  copy: 'clone',
  detail: { path: detailPath, colored: false },
  doubleArrowHorizontal: { path: doubleArrowHorizontalPath, colored: false },
  doubleArrowVertical: { path: doubleArrowVerticalPath, colored: false },
  down: { path: downPath, colored: false },
  draft: { path: draftPath, colored: false },
  editUser: 'edit',
  enterprises: { path: enterprisesPath, colored: false },
  error: 'error',
  errorCluster: { path: errorClusterPath, colored: true },
  excel: 'excel',
  expand: { path: expandPath, colored: false },
  expandControl: 'expand',
  externalCluster: { path: externalClusterPath, colored: true },
  filterCollapse: { path: filterCollapsePath, colored: false },
  filterExpand: { path: filterExpandPath, colored: false },
  general_settings: { path: general_settingsPath, colored: false },
  help: { path: helpPath, colored: false },
  home: { path: homePath, colored: false },
  info: 'info',
  licenses: { path: licensesPath, colored: false },
  minus: { path: minusPath, colored: false },
  more: 'dotsHorizontal',
  neosDataImportAdd: 'add',
  neosDataImportClose: 'close',
  neosDataImportDetail: { path: neosDataImportDetailPath, colored: false },
  neosDataImportDownloadFile: { path: neosDataImportDownloadFilePath, colored: false },
  neosDataImportError: { path: neosDataImportErrorPath, colored: false },
  neosDataImportFile: { path: neosDataImportFilePath, colored: false },
  neosDataImportFilter: 'filter',
  neosDataImportHistory: { path: neosDataImportHistoryPath, colored: false },
  neosDataImportInfo: 'info',
  neosDataImportIntegrate: { path: neosDataImportIntegratePath, colored: false },
  neosDataImportIntegrateAll: { path: neosDataImportIntegrateAllPath, colored: false },
  neosDataImportIntegration: { path: neosDataImportIntegrationPath, colored: false },
  neosDataImportKpiErrorRowCount: { path: neosDataImportKpiErrorRowCountPath, colored: true },
  neosDataImportKpiInformationRowCount: { path: neosDataImportKpiInformationRowCountPath, colored: true },
  neosDataImportKpiIntegratedRowCount: { path: neosDataImportKpiIntegratedRowCountPath, colored: true },
  neosDataImportKpiProcessedRowCount: { path: neosDataImportKpiProcessedRowCountPath, colored: true },
  neosDataImportKpiValidRowCount: { path: neosDataImportKpiValidRowCountPath, colored: true },
  neosDataImportKpiWarningRowCount: { path: neosDataImportKpiWarningRowCountPath, colored: true },
  neosDataImportRightArrow: { path: neosDataImportRightArrowPath, colored: false },
  neosDataImportRun: { path: neosDataImportRunPath, colored: false },
  neosDataImportSettings: { path: neosDataImportSettingsPath, colored: false },
  neosDataImportTemplate: { path: neosDataImportTemplatePath, colored: false },
  neosDataImportUploadFile: { path: neosDataImportUploadFilePath, colored: false },
  neosDataImportValidate: 'validate',
  neosPrint: 'print',
  new: { path: newPath, colored: false },
  noData: { path: noDataPath, colored: true },
  openInNewSharp: { path: openInNewSharpPath, colored: false },
  openTab: { path: openTabPath, colored: false },
  payments: { path: paymentsPath, colored: false },
  plus: { path: plusPath, colored: false },
  preview: { path: previewPath, colored: false },
  print: { path: printPath, colored: false },
  productEditing: { path: productEditingPath, colored: false },
  refresh: 'refresh',
  remove: 'remove',
  reset: 'reset',
  rightPanelCollapse: { path: rightPanelCollapsePath, colored: false },
  rightPanelExpand: { path: rightPanelExpandPath, colored: false },
  roleUsers: { path: roleUsersPath, colored: false },
  rowInsert: { path: rowInsertPath, colored: false },
  save: 'save',
  search: 'search',
  sendEmail: { path: sendEmailPath, colored: false },
  sendSMS: { path: sendSMSPath, colored: false },
  softwareDownload: 'download',
  statistics: { path: statisticsPath, colored: false },
  syncBlack: { path: syncBlackPath, colored: false },
  tenant: { path: tenantPath, colored: false },
  testEnvironment: { path: testEnvironmentPath, colored: false },
  themes: { path: themesPath, colored: false },
  up: { path: upPath, colored: false },
  userAccount: { path: userAccountPath, colored: false },
  userClient: { path: userClientPath, colored: false },
  userFunction: { path: userFunctionPath, colored: false },
  userPermissionsSendEmail: { path: userPermissionsSendEmailPath, colored: false },
  userPermissionsSendSMS: { path: userPermissionsSendSMSPath, colored: false },
  userPublisher: { path: userPublisherPath, colored: false },
  validate: 'validate',
  verticalDots: { path: verticalDotsPath, colored: false },
  warning: 'warning',
}

export default images